module.exports = __webpack_public_path__ + "media/images/universe_landing_pages/hero_banner/component/wedding-desktop-46c66565792109e7dfa2446c1ef3b98e.jpg";